import supabase from '../supabaseClient';

// Loads every Game Plan of a user (no row cap) in pages of 1000.
// deleted=false -> the live history; deleted=true -> soft-deleted rows (Recently deleted).
export async function fetchAllPlans(userId, { deleted = false } = {}) {
  const PAGE = 1000;
  const rows = [];
  for (let from = 0; ; from += PAGE) {
    let q = supabase.from('session_plans').select('*').eq('user_id', userId);
    q = deleted ? q.not('deleted_at', 'is', null) : q.is('deleted_at', null);
    q = deleted ? q.order('deleted_at', { ascending: false }) : q.order('scheduled_date', { ascending: false });
    const { data, error } = await q.order('id').range(from, from + PAGE - 1);
    if (error) return { data: rows, error };
    rows.push(...(data || []));
    if (!data || data.length < PAGE) break;
  }
  return { data: rows, error: null };
}
